

<ion-content class="ion-page brand-default">
  <div class="landing-page-container">
    <div class="signin-register-form-container forgot-password-container">
      <div class="logo-container">
        <a href="/">
          <ion-img id="topmenu-logo" src="{{ logoImagePath }}" alt="Quotify Logo">
          </ion-img>
        </a>
      </div>
      <div class="forgot-password-pane">
        <ion-popover [isOpen]="showUserNotification" (didDismiss)="showUserNotification = false">
          <ng-template>
            <user-notification [userNotification]="userNotification"
              (closeUserNotification)="onUserNotificationClose($event)"></user-notification>
          </ng-template>
        </ion-popover>
        <form [formGroup]="userForgotPasswordForm" (ngSubmit)="onSubmitForm()">
          <h1>Forgot Password</h1>
          <h2>Please enter your email address to reset your password.</h2>
          <div class="form-field">
            <ion-label for="Email" class="light-label">Email</ion-label>
            <ion-input type="email" formControlName="email" id="Email" ngDefaultControl class="rounded-input"></ion-input>
            <error-messages [control]="userForgotPasswordForm.get('email')" [fieldName]="'Email'"></error-messages>
          </div>
          <div class="form-field">
            <ion-button type="submit" strong="true" size="medium" fill="solid">
              Reset Password
              <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
            </ion-button>
          </div>
          <div class="switch-form-container">
            <ion-router-link id ="LoginLink"style=""routerLink="/user/user-login">
              Back to sign in</ion-router-link> 
          </div>
        </form>
      </div>
    </div>
  </div>
</ion-content>
